import { gql } from 'react-apollo';

import {
  BOOK_A_VIEWING_START,
  BOOK_A_VIEWING_SUCCESS,
  BOOK_A_VIEWING_ERROR,
} from '../../constants';

export function bookAViewing(
  listId,
  hostId,
  hostEmail,
  name,
  companyName,
  email,
  phoneNumber,
  preferredDate,
  message
) {

  return async (dispatch, getState, { client }) => {

    dispatch({
      type: BOOK_A_VIEWING_START,
    });

    try {

      let account = getState().account.data;

      let mutation = gql`
          mutation CreateViewingRequest(
            $listId: Int!, 
            $name: String!,
            $companyName: String,
            $email: String!,
            $phoneNumber: String!,
            $preferredDate: String!,
            $message: String
          ){
              CreateViewingRequest(
                listId: $listId,
                name: $name,
                companyName: $companyName,
                email: $email,
                phoneNumber: $phoneNumber,
                preferredDate: $preferredDate,
                message: $message
              ) {
                  status
              }
          }
      `;

      // Send Message
      const { data } = await client.mutate({
        mutation,
        variables: {
          listId,
          name,
          companyName,
          email,
          phoneNumber,
          preferredDate,
          message
        }
      });

      if (data && data.CreateViewingRequest && data.CreateViewingRequest.status == 'success') {
        dispatch({
          type: BOOK_A_VIEWING_SUCCESS,
          payload: {
            bookAViewingSuccess: true
          }
        });
      }
      else {
        dispatch({
          type: BOOK_A_VIEWING_ERROR,
          payload: {
            status: data.status
          }
        });
      }

    } catch (error) {
      dispatch({
        type: BOOK_A_VIEWING_ERROR,
        payload: {
          error
        }
      });
      return false;
    }

    return true;
  };
}


// WEBPACK FOOTER //
// src/actions/bookAViewing/bookAViewing.js